<template>
  <div class="card-item-wrapper p-d-12">
    <div class="card-item">
      <div class="f-regular f-12 f-c-yellow konfirmasi-penghapusan"
           v-if="transaksi.status_hapus === 1 && transaksi.idpermintaanhapus !== 0">
        Menunggu konfirmasi penghapusan
      </div>
      <div class="top-card">
        <input type="text" :id="'idtransaksi-'+transaksi.idtransaksi" class="copy-input" :value="transaksi.idtransaksi">

        <div class="f-semi f-16 f-c-black" v-if="!isSearch">{{ transaksi.idtransaksi }}
          <img src="../../../../assets/icons/copy-full.svg" alt=""
               @click="copyToClipboard(transaksi.idtransaksi)"
               class="m-r-4 copy-area"
               style="height: 24px; margin-top: -2px"
          />
        </div>
        <div class="f-semi f-16 f-c-black" v-else
             v-html="searchHighlight(transaksi.idtransaksi, keySearch)"></div>

        <div class="card-menu-vertical"></div>
      </div>
      <div class="f-regular f-13 f-c-midgrey m-t-4" v-if="transaksiGlobal">
        <img src="../../../../assets/icons/mood-happy.svg" alt=""
             class="m-r-4"
             style="height: 13px; margin-top: -2px"
        />
        <span v-if="transaksi.idcustomer === 'SMARTBOT'">Pembayaran QRIS</span>
        <span v-if="transaksi.idcustomer !== 'SMARTBOT' && !isSearch">{{ transaksi.nama_customer }}
				</span>
        <span v-if="transaksi.idcustomer !== 'SMARTBOT' && isSearch"
              class="f-c-black"
              v-html="searchHighlight(transaksi.nama_customer, keySearch)">
				</span>
      </div>
      <div class="d-flex m-t-4" :class="{ 'm-t-4' : transaksiGlobal}">
        <div class="f-regular f-13 f-c-midgrey m-r-8" v-if="transaksi.jenis === 2">
          <img src="../../../../assets/icons/basket.svg" alt=""
               class="m-r-4"
               style="height: 13px; margin-top: -2px"
          />
          Drop Off
        </div>
        <div class="f-regular f-13 f-c-midgrey m-r-8" v-else>
          <img src="../../../../assets/icons/hand.svg" alt=""
               class="m-r-4"
               style="height: 13px; margin-top: -2px"
          />
          Self Service
        </div>

        <div class="f-regular f-13">
          <img src="../../../../assets/icons/outlet-out-muted.svg" alt=""
               class="m-r-4"
               style="height: 13px; margin-top: -2px"
          />
          <span class="f-c-midgrey" v-if="!isSearch">{{ transaksi.nama_outlet }}</span>
          <span class="f-c-black" v-else v-html="searchHighlight(transaksi.nama_outlet, keySearch)"></span>
        </div>
      </div>
      <div class="f-regular f-13 f-c-midgrey" v-if="transaksi.waktu_diterima !== ''">
        Diterima: {{ transaksi.waktu_diterima }}
      </div>
      <div class="f-regular f-13 f-c-midgrey" v-if="transaksi.jenis === 2 && transaksi.waktu_selesai !== ''">
        Selesai: {{ transaksi.waktu_selesai }}
      </div>

      <div class="separator-line m-x-min m-t-10"></div>
      <div class="bottom-card m-t-8 d-flex-between-center align-items-center" style="position: relative">
        <div class="d-inline">
          <span class="f-semi f-14 f-c-black">Rp. {{ formatRupiah(transaksi.total_harga.toString()) }}</span>
          <span class="badge color-red" v-if="transaksi.status_lunas === 0">Blm Lunas</span>
          <span class="badge color-green" v-else-if="transaksi.status_lunas === 1">Lunas</span>
          <span class="badge color-red" v-else-if="transaksi.status_lunas === 2">Blm Bayar</span>
        </div>
        <div class="f-regular f-12 f-c-midgrey">
          {{ statusTransaksi[transaksi.status_selesai] }}
        </div>
      </div>
      <div
          v-if="transaksi['is_loyalty']===1"
          :id="`card_footer_transaksi_snapclean${transaksi.id}`"
          class="employee card_footer f-12 f-c-secondary-kasir-smartlink f-regular m-x-min confirmed"
      >
        <img
            src="@/assets/icons/ic_phone_whitelabel.svg"
            alt=""
            class="m-r-4"
            style="height: 13px; margin-top: -2px"
        /> Loyalty Apps
      </div>

      <div class="clik"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false">
      </div>
      <div class="dropdown-menu garis-listkomisi">
        <button
            class="dropdown-item icon-2"
            v-if="validateAccess('selfService.read')"
            @click="transaksi.status_hapus === 1 && transaksi.idpermintaanhapus !== 0 ? konfirmasiPenghapusan(transaksi.idpermintaanhapus, $event) : detail(transaksi.idtransaksi, $event)"
        >
					<span class="mar-right-10">
						<img src="../../../../assets/icons/file-text.svg">
					</span>
          Detail Nota
        </button>
        <button class="dropdown-item icon-2" @click="konfirmasiPenghapusan(transaksi.idpermintaanhapus, $event)"
                v-if="transaksiGlobal && transaksi.status_hapus === 1 && validateAccess('deleteSelfService.confirm')"
        >
					<span class="mar-right-10">
						<img src="../../../../assets/icons/clipboard-check.svg">
					</span>
          <b>Konfirmasi</b>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SOProgressBarCircle from "@/so-components/global/ui/SOProgressBarCircle";

export default {
  name: "SOCardTransaksiSnapclean",
  components: {
    SOProgressBarCircle,
  },
  props: {
    transaksi: Object,
    isSearch: Boolean,
    keySearch: String,

    transaksiGlobal: Boolean,
  },
  data() {
    return {
      statusTransaksi: ["Belum Jalan", "Sedang Berjalan", "Selesai"]
    }
  },
  methods: {
    detail(id, event) {
      this.$store.commit("transaksiSnapcleanModule/setScrollPosition", event.pageY)
      this.$router.push(`/transaksi/snapclean/detail/${id}`)
      this.smartTrackingClick("detail_transaksi_snapclean");

    },
    konfirmasiPenghapusan(id, event) {
      this.$store.commit("transaksiSnapcleanModule/setScrollPosition", event.pageY)
      this.$router.push({
        name: "PembatalanTransaksiSnapclean.detail.data",
        params: {id: id},
        query: {back: "TransaksiSnapcleanGlobal"}
      });
      this.smartTrackingClick("konfirm_hapus_transaksi_snapclean");
    },
    copyToClipboard(idtransaksi) {
      var copyText = document.getElementById("idtransaksi-" + idtransaksi);
      copyText.select();
      copyText.setSelectionRange(0, 99999)
      document.execCommand("copy");
      console.log(copyText);
      this.$toast.success("ID " + idtransaksi + " Berhasil Tersalin")
    },
  }
}
</script>

<style scoped>
.konfirmasi-penghapusan {
  background: linear-gradient(90deg, #FFF8E1 0%, #FFFFFF 100%);
  padding: 4px 18px;
  margin: -10px -18px 10px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.copy-area {
  padding-left: 5px;
  position: absolute;
  z-index: 2;
}

.copy-input {
  opacity: 0;
  width: 10px;
  height: 10px;
  position: absolute;
}

.card-item .employee,
.detail .detail-footer {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  margin: 10px -18px -10px -18px !important;
  padding: 8px 18px !important;
  background-image: linear-gradient(to right, #E5F6F5, #FFFFFF);
}

</style>